<template>
    <div
        :class="{
        'birthday-background' : isBirthdayToday
        }">
        <foove-autocomplete @submit="handleSubmit" ref="autocomplete"></foove-autocomplete>
        <div class="mt-3" v-if="!selectedConsumer">
            <!-- Identical button to the in-header one, in the same screen
                 position, so it does not change shape when a child is picked. -->
            <div class="d-flex justify-content-end">
                <div v-if="recentlyMadeOrderIds" class="recent-order-inline mb-2">
                    <b-button variant="outline-danger" size="sm" :disabled="canceling"
                              @click="confirmCancelRecentlyMadeOrders">
                        <b-spinner v-if="canceling" small class="mr-1"></b-spinner>
                        <b-icon v-else icon="arrow-counterclockwise" class="mr-1"></b-icon>
                        {{ recentOrderButtonText }}
                    </b-button>
                </div>
            </div>
            <locations-menu-items></locations-menu-items>
        </div>
        <div v-if="selectedConsumer">
            <base-section>
                <b-card-group deck>
                    <div class="d-flex flex-column flex-grow-1 p-3">
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <h4 :class="[color, 'title']">
                                {{ consumerName }} ({{ selectedConsumer.locationGroup }})
                                <b-icon icon="x-circle-fill" scale="1" variant="danger"
                                        @click="cancelConsumer"></b-icon>
                            </h4>
                            <!-- Deliberately NOT about the consumer above: outlined,
                                 prefixed with an undo icon and carrying the other
                                 child's own name so the two can't be confused. -->
                            <div v-if="recentlyMadeOrderIds" class="recent-order-inline">
                                <b-button variant="outline-danger" size="sm" :disabled="canceling"
                                          @click="confirmCancelRecentlyMadeOrders">
                                    <b-spinner v-if="canceling" small class="mr-1"></b-spinner>
                                    <b-icon v-else icon="arrow-counterclockwise" class="mr-1"></b-icon>
                                    {{ recentOrderButtonText }}
                                </b-button>
                            </div>
                        </div>

                        <preordered-menu
                            v-if="selectedConsumer.preOrderedItems.length"
                            :menuItems="selectedConsumer.preOrderedItems"
                            :class="{'margin-of-top' : isBirthdayToday}"
                        />
                        <pickedup-menu
                            v-if="selectedConsumer.pickedUpPreOrderedItems.length || selectedConsumer.pickedUpPosOrderedItems.length"
                            :menuItems="selectedConsumer.pickedUpPreOrderedItems.concat(selectedConsumer.pickedUpPosOrderedItems)"
                            class=""
                        />
                        <div v-if="cartHasMenuItems && isCreditPayment">
                            <br>
                            <h4>Neue Buchung</h4>
                            <hr style="border-bottom: 2px solid $accent-color;">
                        </div>
                        <div v-if="cartHasMenuItems && isCreditPayment" class="mt-auto">
                            <div class="row">
                                <div class="col-10">
                                    <h3>Gesamtpreis: {{ total.toFixed(2) }} €
                                    </h3>
                                </div>
                                <div class="col-2">
                                    <div class="d-flex">
                                        <b-button class="ml-auto py-4" variant="primary" :disabled="ordering"
                                                  @click="payByCredit">
                                            <b-spinner v-if="ordering" small class="mr-2"></b-spinner>
                                            Buchen
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isPreorderedPayment" class="mt-auto">
                            <div class="row">
                                <div class="col-10">
                                    <h3 v-if="cartHasMenuItems">Gesamtpreis: {{ total.toFixed(2) }} €</h3>
                                </div>
                                <div class="col-2">
                                    <div class="d-flex">
                                        <b-button class="ml-auto py-4" variant="primary" :disabled="ordering"
                                                  @click="pickedupPreOrder">
                                            <b-spinner v-if="ordering" small class="mr-2"></b-spinner>
                                            Bestätigen
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card-group>
            </base-section>
            <base-section>
                <div v-if="loading" class="d-flex justify-content-center mb-3">
                    <b-spinner
                        variant="secondary"
                        label="Loading..."
                        style="width: 3rem; height: 3rem;"
                    ></b-spinner>
                </div>
                <div v-else-if="availableMenuItems.length">
                    <b-table
                        striped
                        hover
                        show-empty
                        small
                        stacked="md"
                        :items="availableMenuItems"
                        :fields="fields"
                        :tbody-tr-class="[rowClass, 'sl-menu-row']"
                        :tbody-class="[rowClass, 'sl-menu-body']"
                        class="order sl-menu-table"
                    >
                        <template v-slot:cell(name)="row">
                            <div style="font-size: 18px;">
                            <span
                                :class="{ 'font-weight-bold': true, 'sl-menu-name':true, 'is_maxi': row.item.is_maxi }">{{
                                    row.item.categoryName
                                }}:</span><br>
                                {{ row.value }}
                            </div>
                        </template>
                        <template v-slot:cell(price)="row">
                            <div style="min-width: 55px">
                                {{ row.value }} €
                            </div>
                        </template>
                        <template v-slot:cell(pickedup)="row">
                            <div>{{ row.item.countPreOrderedItems }}/{{ row.item.countPickedItems }}
                            </div>
                        </template>
                        <template v-slot:cell(spontaneous)="row">
                            <div>{{ row.item.countSpontaneousItems }}</div>
                        </template>
                        <template v-slot:cell(quantity)="row">
                            <div style="min-width: 137px">
                                <b-button pill variant="danger" size="lg" @click="decrease(row.index)"
                                          :disabled="cartProcess"
                                          class="font-weight-bold minus sl-button-minus">-
                                </b-button>
                                <div class="quantity mx-2">{{ row.value }}</div>

                                <b-button pill variant="primary" size="lg" v-show="!disabledBtn(row)"
                                          @click="increase(row.index)"
                                          :disabled="disabledBtn(row) || cartProcess"
                                          class="font-weight-bold plus sl-button-plus">+
                                </b-button>

                                <img :src="require('../assets/cross_btn.svg')"
                                     v-if="disabledBtn(row)"
                                     class="cursor-pointer"
                                     :id="`show-validation-message-${row.index}`"
                                >
                                <b-popover :target="`show-validation-message-${row.index}`" :triggers="['click']"
                                           placement="bottom">
                                    <template #title></template>
                                    <span>Nicht genügend Guthaben</span>
                                </b-popover>
                            </div>
                        </template>
                        <template v-slot:cell(total)="row">
                            <div class="total">
                                {{ ((row.item.price * 100 * row.item.quantity) / 100).toFixed(2) }}
                                €
                            </div>
                        </template>
                    </b-table>
                </div>
                <div v-else>
                    <base-subheading>Keine Einträge vorhanden</base-subheading>
                </div>
            </base-section>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters}                                             from "vuex";
import {getAllMenuItemsRequest}                                             from "@/api/menu-items";
import {API_ENDPOINT}                                                       from "@/configs";
import BaseSection                                                          from "@/components/base/Section";
import BaseSubheading                                                       from "@/components/base/Subheading";
import PreorderedMenu                                                       from "@/components/menu/PreorderedMenu";
import {cancelRecentlyMadeOrders, createFoodOrderRequest, pickedupPreOrder} from "@/api/food-order";
import {getConsumerById}                                                    from "@/api/consumers";
import PickedupMenu                                                         from "@/components/menu/PickedupMenu";
import {allVoucherOrders, pickedVoucherOrders}                              from "../utils/helpers";
import {removeFoodOrderRequest}                                             from "../api/food-order";

import LocationsMenuItems                   from "@/components/menu/LocationsMenuItems";
import FooveAutocomplete                    from '@/components/autocomplete/Autocomplete.vue';
import {create, decrease, increase, remove} from "@/api/cart";
import cartMixin                            from "@/mixins/cartMixin";

/**
 * OrderService::remove() refuses to cancel a POS order more than 5 minutes
 * after pickup, so the undo button expires with the same window instead of
 * lingering on screen and failing when it is finally pressed.
 */
const RECENTLY_MADE_ORDER_TTL = 5 * 60 * 1000;

export default {
    name:       'MenuItems',
    components: {
        FooveAutocomplete,
        PreorderedMenu,
        PickedupMenu,
        BaseSection,
        BaseSubheading,
        LocationsMenuItems,
    },
    mixins:     [cartMixin],
    data() {
        return {
            recentlyMadeOrderIds:          null,
            recentlyMadeOrderType:         1,
            recentlyMadeOrderConsumerName: '',
            recentlyMadeOrderTotal:        0,
            recentlyMadeOrderTimeoutId:    null,
            availableMenuItems:            [],
            selectedMenu:                  [],
            API_ENDPOINT,
            fields:                [
                {key: 'name', label: 'Name'},
                {key: 'price', label: 'Preis'},
                {key: 'pickedup', label: 'Bestellt/ Abgeholt'},
                {key: 'spontaneous', label: 'Spontan- essen'},
                {key: 'quantity', label: ''},
                {key: 'total', label: 'Summe'},
                {key: 'action', label: ''},
            ],
            loading:                       false,
            ordering:                      false,
            canceling:                     false,
            cartProcess:                   false,
            limitMessageState:             true,
            enableSearch:                  false,
        };
    },
    computed: {
        ...mapGetters(['selectedConsumer']),
        ...mapActions(['setLimitOrders']),
        total() {
            return this.availableMenuItems.length ? this.availableMenuItems.reduce(function (acc, obj) {
                return acc + obj.price * obj.quantity;
            }, 0) : 0;
        },
        isBirthdayToday() {
            return this.selectedConsumer
                && new Date(this.selectedConsumer.birthday).getDate() === new Date().getDate()
                && new Date(this.selectedConsumer.birthday).getMonth() === new Date().getMonth()
        },
        isPreorderedPayment() {
            return this.selectedConsumer && this.selectedConsumer.preOrderedItems.length;
        },
        isCreditPayment() {
            return this.selectedConsumer && !this.selectedConsumer.preOrderedItems.length;
        },
        cartHasSubsidyMenuItem() {
            return this.availableMenuItems.some(item => item.quantity > 0 && item.is_subsidized === true);
        },
        cartHasMenuItems() {
            return this.availableMenuItems.some(item => item.quantity > 0);
        },
        consumerName() {
            return `${this.selectedConsumer.firstname} ${this.selectedConsumer.lastname}`;
        },
        // Never the consumer on screen: the undo button always refers to the
        // booking that was made before the current one was selected.
        recentlyMadeOrderLabel() {
            return this.recentlyMadeOrderConsumerName || 'der letzten Person';
        },
        // Built here rather than in the template: vue-loader's whitespace
        // handling drops the separator's leading space between two elements,
        // and both call sites must read identically anyway.
        recentOrderButtonText() {
            const parts = [this.recentlyMadeOrderLabel];

            if (this.recentlyMadeOrderTotal > 0) {
                parts.push(`${this.recentlyMadeOrderTotal.toFixed(2)} €`);
            }

            parts.push(this.recentlyMadeOrderType === 1 ? 'Abholung abbrechen' : 'stornieren');

            return parts.join(' · ');
        },
        color() {
            let color = 'red';
            if (this.selectedConsumer.preOrderedItems.length) {
                color = 'green';
            } else if (this.selectedConsumer.pickedUpPreOrderedItems.length) {
                color = 'yellow';
            }
            return color;
        }
    },
    mounted() {
        this.setVoucherLimitMessageState()
    },
    async created() {
        if (this.selectedConsumer) {
            await this.handleSubmit(this.selectedConsumer);
        }
    },
    beforeDestroy() {
        this.clearRecentlyMadeOrder();
    },
    methods: {
        async confirmCancelRecentlyMadeOrders() {
            if (!this.recentlyMadeOrderIds || this.canceling) return;

            const name   = this.recentlyMadeOrderLabel;
            const amount = this.recentlyMadeOrderTotal > 0
                ? ` über ${this.recentlyMadeOrderTotal.toFixed(2)} €`
                : '';
            const question = this.recentlyMadeOrderType === 1
                ? `Abholung von ${name}${amount} wirklich abbrechen?`
                : `Buchung von ${name}${amount} wirklich stornieren?`;

            const confirmed = await this.$bvModal.msgBoxConfirm(question, {
                title:         'Bitte bestätigen',
                centered:      true,
                okVariant:     'danger',
                okTitle:       'Ja, stornieren',
                cancelTitle:   'Abbrechen',
                cancelVariant: 'outline-secondary',
            });

            if (!confirmed) return;

            await this.cancelRecentlyMadeOrders(this.recentlyMadeOrderIds, this.recentlyMadeOrderType);
        },
        async cancelRecentlyMadeOrders(recentlyMadeOrderIds, recentlyMadeOrderType) {
            this.canceling = true;

            try {
                if (recentlyMadeOrderType === 1) {
                    await cancelRecentlyMadeOrders({orderIds: recentlyMadeOrderIds});
                } else {
                    // One request per order: the route is order/{id}, so a joined
                    // "1,2" only ever matched order 1 and silently left the rest
                    // of the booking in place.
                    for (const orderId of recentlyMadeOrderIds) {
                        await removeFoodOrderRequest(orderId);
                    }
                }

                this.clearRecentlyMadeOrder();
                await this.$store.dispatch('setLimitOrders');
            } catch (e) {
                // The response interceptor already showed the backend message.
                // Keep the button so the cashier can see nothing was cancelled.
            } finally {
                this.canceling = false;
            }
        },
        clearRecentlyMadeOrder() {
            this.recentlyMadeOrderIds          = null;
            this.recentlyMadeOrderType         = 1;
            this.recentlyMadeOrderConsumerName = '';
            this.recentlyMadeOrderTotal        = 0;

            if (this.recentlyMadeOrderTimeoutId) {
                clearTimeout(this.recentlyMadeOrderTimeoutId);
                this.recentlyMadeOrderTimeoutId = null;
            }
        },
        rememberRecentlyMadeOrder(orderIds, orderType) {
            this.clearRecentlyMadeOrder();

            this.recentlyMadeOrderIds  = orderIds;
            this.recentlyMadeOrderType = orderType;
            // Captured while the consumer is still selected: afterOrderEvents()
            // clears the selection right after this, and the button outlives it.
            this.recentlyMadeOrderConsumerName = this.selectedConsumer ? this.consumerName : '';
            this.recentlyMadeOrderTotal        = orderType === 1 && this.selectedConsumer
                ? this.getCartTotalPrice(this.selectedConsumer.preOrderedItems || [])
                : this.total;

            this.recentlyMadeOrderTimeoutId = setTimeout(
                () => this.clearRecentlyMadeOrder(),
                RECENTLY_MADE_ORDER_TTL
            );
        },
        async cancelConsumer() {
            await remove({
                consumer_id: this.selectedConsumer.consumer_id
            });
            await this.setSelectedConsumer(null);
            await this.$router.push({name: "menu-items"});
        },
        ...mapActions(['preOrderedPayment', 'setSelectedConsumer', 'setIntervalId', 'setAutocompleteFocus']),
        ...mapGetters(['extraMeals', 'limitOrders']),
        async decrease(index) {
            if (this.selectedConsumer && this.availableMenuItems[index]['cart_item_id']) {
                this.cartProcess = true;

                await decrease({
                    'consumer_id':               this.selectedConsumer.consumer_id,
                    'menu_item_id':              this.availableMenuItems[index]['menuitem_id'],
                    'cart_item_id':              this.availableMenuItems[index]['cart_item_id'],
                    'location_menu_category_id': this.availableMenuItems[index]['location_menu_category_id'],
                    'subsidization_rule_id':     this.availableMenuItems[index]['subsidization_rule_id'],
                }).then(async () => {
                    await this.updateConsumerBalance();
                    await this.getAllMenuItems();
                    this.cartProcess = false;
                });
            }

            this.setVoucherLimitMessageState(index)
        },
        async increase(index) {
            if (this.selectedConsumer) {
                this.cartProcess = true;

                await increase({
                    'consumer_id':               this.selectedConsumer.consumer_id,
                    'menu_item_id':              this.availableMenuItems[index]['menuitem_id'],
                    'location_menu_category_id': this.availableMenuItems[index]['location_menu_category_id'],
                    'subsidization_rule_id':     this.availableMenuItems[index]['subsidization_rule_id'],
                }).then(async () => {
                    await this.updateConsumerBalance();
                    await this.getAllMenuItems();
                    this.cartProcess = false;
                }).catch(async () => {
                    // if select consumer balance bigger than retrieved consumer => update balance
                    await this.updateConsumerBalance();
                    await this.createConsumerCart();
                    await this.getAllMenuItems();
                });
            }
            this.setVoucherLimitMessageState(index)
        },
        remove() {

        },
        rowClass(item, type) {
            return (item && type === 'row' && item.quantity > 0) ? 'ordered' : null;
        },
        async updateConsumerBalance() {
            if (!this.selectedConsumer) return;

            await getConsumerById(this.selectedConsumer.consumer_id)
                .then(async (response) => {
                    //update orders data
                    if ((this.toCorrectFloat(this.selectedConsumer.coefficient) >= this.toCorrectFloat(response.data.coefficient)) || !this.cartHasMenuItems)
                        this.selectedConsumer.coefficient = response.data.coefficient;

                    this.selectedConsumer.pickedUpPreOrderedItems = response.data.pickedUpPreOrderedItems;
                    this.selectedConsumer.pickedUpPosOrderedItems = response.data.pickedUpPosOrderedItems;
                    this.selectedConsumer.preOrderedItems         = response.data.preOrderedItems;
                });
        },
        async payByCredit() {
            if (!this.cartHasMenuItems || !this.selectedConsumer) return;

            this.ordering = true;

            await createFoodOrderRequest({
                consumer_id: this.selectedConsumer.consumer_id
            }).then(async (response) => {
                await this.afterOrderEvents(response);
            })
                .catch(async () => {
                    // if select consumer balance bigger than retrieved consumer => update balance
                    await this.updateConsumerBalance();
                    await this.createConsumerCart();
                    await this.getAllMenuItems();
                    this.ordering = false;
                });
        },
        async pickedupPreOrder() {
            if (!this.isPreorderedPayment || !this.selectedConsumer) return;

            this.ordering = true;
            // also submit POS orders if cart not empty
            await pickedupPreOrder(this.selectedConsumer.preOrderedItems)
                .then(async (response) => {
                    if (this.cartHasMenuItems) {
                        await createFoodOrderRequest({
                            consumer_id: this.selectedConsumer.consumer_id
                        })
                    }

                    await this.afterOrderEvents(response);
                })
                .catch(async () => {
                    // if select consumer balance bigger than retrieved consumer => update balance
                    await this.updateConsumerBalance();
                    await this.createConsumerCart();
                    await this.getAllMenuItems();
                    this.ordering = false;
                });

            await this.setLimitOrders;
        },
        async afterOrderEvents(response) {
            if (response.data.orderIds) {
                this.rememberRecentlyMadeOrder(response.data.orderIds, response.data.orderType);
            }

            await this.setSelectedConsumer(null);
            this.loading = true;
            await this.getAllMenuItems();
            this.loading  = false;
            this.ordering = false;

            if (response.data.skip_notification) {
                this._showItemCanceledMessage(response)
            }

            await this.$store.dispatch('setLimitOrders');
        },
        disabledBtn(row) {
            if (this.selectedConsumer) {
                return row.item.is_permit_to_add === false;
            }

            return false;
        },

        async handleSubmit(result) {
            if (typeof result == 'undefined') return;

            if (this.$refs.autocomplete)
                this.$refs.autocomplete.clearSearchInput();

            if (this.selectedConsumer && this.selectedConsumer.consumer_id !== result.consumer_id) {
                await this.pickedupPreOrder();
                await this.payByCredit();
            }

            // if select consumer balance bigger than retrieved consumer => update balance
            this.loading = true;
            await this.updateConsumerBalance();
            await this.setSelectedConsumer(result);
            await this.createConsumerCart();
            await this.getAllMenuItems();
            this.loading = false;
        },
        async getAllMenuItems() {
            if (this.selectedConsumer) {
                this.cartProcess = true;

                await getAllMenuItemsRequest({
                    locationId: this.selectedConsumer.location_id,
                    consumerId: this.selectedConsumer.consumer_id,
                })
                    .then(res => {
                        this.availableMenuItems = res.data
                        this.cartProcess        = false;
                    });
            }
        },
        async createConsumerCart() {
            if (this.selectedConsumer) {
                await create({
                    'consumer_id': this.selectedConsumer.consumer_id
                });
            }
        },
        _showItemCanceledMessage: function (res) {
            const h = this.$createElement;

            let vNodesMsg = h(
                'div',
                {
                    class: ['modal-success-text-size']
                },
                [
                    res.data.message
                ]
            );

            let vNodesTitle = h(
                'div',
                {
                    class: ['modal-success-title-size']
                },
                [
                    'Vielen Dank!'
                ]
            );

            this._showToastError(vNodesMsg, vNodesTitle);
        },
        _showToastError(message = '', title = 'Error') {
            this.$bvToast.toast(message, {
                toaster:       'b-toaster-top-center',
                title:         title,
                variant:       'success',
                autoHideDelay: 500,
            });
        },
        /** @todo - fix this after */
        setVoucherLimitMessageState(index = null) {
            let voucherLimit = allVoucherOrders(this.extraMeals());

            if (index === null) {
                this.limitMessageState = voucherLimit <= pickedVoucherOrders(this.limitOrders());
            } else {
                this.limitMessageState = voucherLimit >= this.availableMenuItems[index]['quantity']
            }
        }
    },
}
</script>

<style scoped>
.search {
    padding-top: 10px;
}

/* Sits in the consumer header row, so it must stay clearly secondary to the
   name next to it and must not grow that row's height. */
.recent-order-inline .btn {
    font-size: 15px;
    padding: 6px 14px;
    white-space: nowrap;
}

>>> .search .autocomplete-input {
    padding: 8px 12px 8px 48px;
}

>>> .order th {
    vertical-align: top;
}

>>> .order tr th div {
    line-height: 18px;
}

>>> .order tr th:nth-child(4) div {
    max-width: 80px;
}

>>> .order tr th:nth-child(5) div {
    max-width: 70px;
}

>>> .order td {
    vertical-align: inherit;
    font-size: 14px;
    padding: 4px;
}

.img-wrapper {
    width: 80px;
}

h3 {
    margin-bottom: 30px;
}

.quantity {
    min-width: 30px;
    display: inline-block;
    text-align: center;
}

.total {
    min-width: 90px;
    display: inline-block;
}

>>> .order tbody tr.ordered {
    background: #f4e1b6;
}

.purchase {
    display: flex;
    justify-content: space-between;
}

>>> .card {
    border-width: 2px;
    border-style: solid;
}

>>> .card.green {
    border-color: $ green;
}

>>> .card.yellow {
    border-color: $ yellow;
}

>>> .card.red {
    border-color: $ red;
}

>>> .cart-has-subsidy-menu-item {
    background-color: rgba(157, 183, 89, 0.47);
    padding: 1px 8px;
    border-radius: 6px;
    font-size: 18px;
}

h4.title {
    position: relative;
    padding-left: 35px;
    font-weight: 700;
    margin-left: 15px;
}

h4.title:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
    border-radius: 50%;
}

h4.green {
    border-color: #298b3f;
}

h4.green:before {
    background: #298b3f;
}

h4.yellow {
    color: #ead239;
}

h4.yellow:before {
    background: #ead239;
}

h4.red {
    color: #ec3d51;
}

h4.red:before {
    background: #ec3d51;
}

>>> .btn-success.disabled, >>> .btn-success:disabled {
    color: #aaaaaa;
    background-color: #aaaaaa;
    border-color: #aaaaaa;
    position: relative;
}

>>> .btn-success.disabled:before,
>>> .btn-success.disabled:after {
    content: '';
    position: absolute;
    width: 40px;
    height: 4px;
    background-color: $ red;
    border-radius: 0;
    top: 18px;
    -webkit-transition: 150ms ease-out;
    -moz-transition: 150ms ease-out;
    -o-transition: 150ms ease-out;
    transition: 150ms ease-out;
    z-index: 0;
}


>>> .btn-success.disabled:before {
    -webkit-transform: rotate(225deg);
    -moz-transform: rotate(225deg);
    transform: rotate(225deg);
    left: 0px;
}

>>> .btn-success.disabled:after {
    -webkit-transform: rotate(-225deg);
    -moz-transform: rotate(-225deg);
    transform: rotate(-225deg);
    right: 0px;
}

button.minus {
    padding: 5px 16px;
}

button.plus {
    padding: 5px 14px;
}

.round-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    cursor: pointer;
    color: #ffffff;
}

.btn-remove {
    cursor: pointer;
}

.disabled-buy-button {
    opacity: 0.65;
}

>>> .modal-success-title-size {
    font-size: 18px;
    text-align: center !important;

}

>>> .modal-success-text-size {
    font-size: 17px;
}

>>> .autocomplete[data-loading=true]:after {
    content: none !important;
}

.is_maxi {
    background-color: $light-grey !important;
    padding: 4px;
    margin-left: -4px;
    background: border-box;
    border-radius: 5px;
}

.hint-no-balance {
    color: rgb(230 122 137);
}

.birthday-background {
    background-image: url('./../assets/users/happy_birthday.png');
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: top -56px right;
    height: 162px;
}

.margin-of-top {
    margin-top: 37px;
}
</style>
